import { Node, mergeAttributes } from '@tiptap/core'
import { buildResourceTableInsertContent } from '../lib/post_block_indent.js'
import {
  afterResourceRowInsertFocus,
  resolveResourceTableRowInsert,
  RESOURCE_ROW_TITLE_PARAGRAPH_ATTRS,
} from '../lib/resource_row_paragraph.js'

export const MeetingExtension = Node.create({
  name: 'meeting',

  group: 'block',

  content: 'meetingRow+',

  defining: true,

  addAttributes() {
    return {}
  },

  parseHTML() {
    return []
  },

  renderHTML() {
    // This extension no longer renders containers
    return ['div']
  },

  addCommands() {
    return {
      setMeeting:
        (options) =>
        ({ commands, editor, state }) => {
          const ok = commands.insertContent(
            buildResourceTableInsertContent(state, [
              {
                type: 'meetingRow',
                attrs: options,
                content: [
                  {
                    type: 'paragraph',
                    attrs: RESOURCE_ROW_TITLE_PARAGRAPH_ATTRS,
                    content: [{ type: 'text', text: 'Click to edit title' }],
                  },
                ],
              },
            ])
          );
          if (ok && editor) {
            afterResourceRowInsertFocus(editor, state, {
              resourceId: options?.resourceId,
              rowType: 'meetingRow',
            });
          }
          return ok;
        },

      addMeetingRow:
        (options) =>
        ({ commands, editor, state }) => {
          const insertCtx = resolveResourceTableRowInsert(state);
          const ok = commands.insertContent({
            type: 'meetingRow',
            attrs: options,
            content: [
              {
                type: 'paragraph',
                attrs: RESOURCE_ROW_TITLE_PARAGRAPH_ATTRS,
                content: [{ type: 'text', text: 'Click to edit title' }],
              },
            ],
          });
          if (ok && editor) {
            afterResourceRowInsertFocus(editor, state, {
              resourceId: options?.resourceId,
              rowType: 'meetingRow',
              insertCtx,
            });
          }
          return ok;
        },
    }
  },
})

export const MeetingRowExtension = Node.create({
  name: 'meetingRow',

  group: 'block',

  content: 'paragraph+',

  defining: true,

  addAttributes() {
    return {
      href: {
        default: null,
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'tr[data-resource-row]',
        priority: 100,
        getAttrs: element => {
          const href = element.getAttribute('data-href') || element.getAttribute('href') || null;
          const isMeeting =
            element.querySelector('img[src*="meeting-icon.svg"]') ||
            element.querySelector('.icon-ps-video') ||
            element.getAttribute('data-row-type') === 'meeting';
          return isMeeting ? { href, rowType: 'meeting' } : false;
        },
        contentElement: element => {
          const textCell = element.querySelector('td:last-child');
          return textCell;
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    const { href } = HTMLAttributes;

    const elementAttrs = mergeAttributes(HTMLAttributes, {
      'data-resource-row': '',
      'data-row-type': 'meeting',
    });

    if (href) {
      const formattedUrl = href.startsWith('http://') || href.startsWith('https://') ? href : `https://${href}`;
      elementAttrs.style = 'cursor: pointer;';
      elementAttrs.onclick = `
        const editor = window.currentTiptapEditor;
        if (!editor || !editor.isEditable) {
          window.open('${formattedUrl}', '_blank');
        }
      `;
      elementAttrs['data-href'] = formattedUrl;
    }

    return [
      'tr',
      elementAttrs,
      [
        'td',
        { 
          colspan: '1', 
          rowspan: '1'
        },
        [
          'span',
          {
            class: 'ps-resource-row__icon',
            draggable: 'false',
            contenteditable: 'false',
            'data-resource-row-icon': 'meeting',
          },
          ['span', { class: 'icon-ps-video', 'aria-hidden': 'true' }],
        ],
      ],
      [
        'td',
        { 
          colspan: '1', 
          rowspan: '1',
          class: 'meeting-title font-primary-bold',
        },
        0
      ]
    ];
  },

  addCommands() {
    return {}
  },

})
